// extracted by mini-css-extract-plugin
export var animationContainer = "_gv-0";
export var asteriskIcon = "_gv-8";
export var conversationLeftSection = "_gv-4";
export var conversationListItem = "_gv-3";
export var conversationMiddleSection = "_gv-5";
export var conversationRightSection = "_gv-6";
export var detailsContent = "_gv-1";
export var listContainer = "_gv-7";
export var modalContent = "_gv-2";